import MetaMaskLogo from "assets/images/wallet/matemask_wallet.png";
import OkxLogo from "assets/images/wallet/okx_wallet.png";
import CoinbaseLogo from "assets/images/wallet/coinbase_wallet.png";
import TokenpocketLogo from "assets/images/wallet/tp_wallet.png";
import BitgetLogo from "assets/images/wallet/bitget_wallet.png";
import WalletconnectLogo from "assets/images/wallet/connect_wallet.png";
import PaliLogo from 'assets/images/wallet/pali_wallet.png'
import UnisatLogo from 'assets/images/wallet/unisat.png'

import { WalletInfo } from "types/baseType";

export const supportWallet : WalletInfo[] = [
    {
      name: "MetaMask",
      icon: MetaMaskLogo,
    },
    // {
    //   name: "BitgetWallet",
    //   icon: BitgetLogo,
    // },
    {
      name: "OkxWallet",
      icon: OkxLogo,
    },
    // {
    //   name: "TokenPocket",
    //   icon: TokenpocketLogo,
    // },
    // {
    //   name: "CoinBase",
    //   icon: CoinbaseLogo,
    // },
    // {
    //   name: "Pali",
    //   icon: PaliLogo,
    // },
    // {
    //   name: "WalletConnect",
    //   icon: WalletconnectLogo
    // }
]

export const supportWalletByBRC20 : WalletInfo[] = [
  {
    name: "OkxWallet",
    flag: 'okx_bitcoin',
    icon: OkxLogo,
  },
  {
    name: "Unisat",
    flag: 'unisat',
    icon: UnisatLogo
  }
]


export const getWalletLogo = (walletName: string) => {
    walletName = walletName.toLowerCase()
    if(walletName === 'metamask') {
      return MetaMaskLogo
    } else if(walletName === 'okxwallet') {
      return OkxLogo
    } else if(walletName === 'bitgetwallet') {
      return BitgetLogo
    } else if(walletName === 'pali') {
      return PaliLogo
    } else if(walletName === 'coinbase') {
      return CoinbaseLogo
    } if(walletName === 'tokenpocket') {
      return TokenpocketLogo
    } else if(walletName === 'walletconnect') {
      return WalletconnectLogo
    } else if(walletName === 'unisat') {
      return UnisatLogo
    }
}